export default "__VITE_ASSET__DDs$Zb$d__"